import NavigableValidation from "./navigableValidation";
import WorkflowStepActionValidator from "../navigableValidators/workflowStepActionValidator";
import WorkflowStepAction from "../../../formability/form_builder/models/workflow/workflowStepAction";
import {ValidationModalSection} from "~/models/navigableValidations/validationSections";

export default class WorkflowStepActionValidation<T> extends NavigableValidation<WorkflowStepAction> {
  validators = [
    new WorkflowStepActionValidator({
      section: ValidationModalSection.Workflow
    })
  ];

  protected buildQuery(validatorKey, value?): {} {
    return {
      endStepId: value.jump_to_client_id,
    };
  }
}
